// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_it","scoreNumber":"e_jt","scoreStars":"e_kt","badge":"e_lt","badgeImage":"e_mt"};